import { Icons } from '@commenda/kakashi';

const SalesTaxPageHeader = ({
  renderHeader,
  onNavigate,
}: {
  renderHeader: () => React.ReactNode;
  onNavigate: () => void;
}) => {
  return (
    <div className="px-6 py-4 flex items-center justify-between border border-t-0 border-l-0 border-r-0">
      {renderHeader && renderHeader()}

      <div className="flex items-center gap-2">
        <Icons.X
          onClick={onNavigate}
          className="w-5 h-5 text-text-quaternary cursor-pointer hover:text-text-primary"
        />
      </div>
    </div>
  );
};

export default SalesTaxPageHeader;
